import { useConfigStore } from "../../Stores/Config";

// UI copy for the v2 renderer. Keys resolve through the project's static
// translations when the server ships them; English is the fallback.
const DEFAULTS = {
  svSurvey: "Survey",
  svNext: "Next",
  svSubmit: "Submit",
  svOk: "OK",
  svSkip: "Skip",
  svContinue: "Continue",
  svStart: "Start",
  svTakesAboutOne: "Takes about 1 minute",
  svTakesAbout: "Takes about {n} minutes",
  svPressEnter: "press",
  svEnter: "Enter",
  svOptional: "(optional)",
  svTypeAnswer: "Type your answer here…",
  svEmailPlaceholder: "name@example.com",
  svNumberPlaceholder: "Type a number…",
  svOther: "Other",
  svOtherPlaceholder: "Type your answer…",
  svYes: "Yes",
  svNo: "No",
  svNotLikely: "Not likely",
  svVeryLikely: "Very likely",
  svAnswerSaved: "Answer saved",
  svSaved: "Saved",
  svSaving: "Saving…",
  svOffline: "Offline · retrying",
  svPercentCompleted: "{p}% completed",
  svQuestionOfAbout: "Question {n} of about {total}",
  svPoweredBy: "Powered by Gleap",
  svClose: "Close survey",
  svPrevious: "Previous question",
  svNextQuestion: "Next question",
  svChooseFile: "Choose a file",
  svDropFile: "or drag it here",
  svUploading: "Uploading…",
  svRemoveFile: "Remove file",
  svUploadFailed: "Upload failed. Please try again.",
  svErrRequired: "Please answer this question.",
  svErrEmail: "Please enter a valid email address.",
  svErrNumber: "Please enter a number.",
  svErrDate: "Please enter a valid date.",
  svErrMinSelect: "Please choose at least {n}.",
  svErrMaxSelect: "Please choose at most {n}.",
  svErrOther: "Please tell us a bit more.",
  svChooseUpTo: "Choose up to {n}",
  svChooseAtLeast: "Choose at least {n}",
  svChooseBetween: "Choose {min}–{max}",
  svChooseAny: "Choose as many as you like",
  svFrom: "from",
  svStarsOf: "{n} of {max}",
  svQuestion: "Question {n}",
  svCharsLeft: "{n} characters left",
  svErrConsent: "Please tick the box to continue.",
  svErrFileType: "This file type isn't accepted here.",
};

export type SurveyStringKey = keyof typeof DEFAULTS;

export const useSurveyStrings = () => {
  const translate = useConfigStore((state) => state.translateTextWithFallback);
  return (key: SurveyStringKey, vars?: Record<string, string | number>) => {
    let text = translate(key, DEFAULTS[key]);
    if (vars) {
      text = text.replace(/\{(\w+)\}/g, (_m, name) =>
        vars[name] !== undefined ? String(vars[name]) : "",
      );
    }
    return text;
  };
};

export type SurveyStrings = ReturnType<typeof useSurveyStrings>;
